module.exports = __webpack_public_path__ + "img/home-country.7bfdb845.png";